import { getOrganizationPageNewsletterUrl } from "@simplyk/common";
import { useRouter } from "next/router";

import { useInitialNewsletter } from "../Context/InitialNewsletterContext";

const OPENED_NEWSLETTER_PATH = /\/newsletters\/([0-9a-f-]{36})(?:[/?#]|$)/i;

export const useOpenedNewsletter = ({
  organizationId,
  organizationPageUrl,
}: {
  organizationId: string;
  organizationPageUrl: string;
}) => {
  const router = useRouter();
  const initialNewsletter = useInitialNewsletter();
  const openedNewsletterId = router.asPath.match(OPENED_NEWSLETTER_PATH)?.[1] ?? null;

  const replaceUrlOnCurrentPage = (path: string) =>
    router.push(
      {
        pathname: router.pathname,
        query: initialNewsletter ? { organizationId, newsletterId: initialNewsletter.id } : { organizationId },
      },
      path,
      { shallow: true, scroll: false, locale: false }
    );

  const openNewsletter = (newsletterId: string) =>
    replaceUrlOnCurrentPage(new URL(getOrganizationPageNewsletterUrl(organizationPageUrl, newsletterId)).pathname);

  const closeNewsletter = () => replaceUrlOnCurrentPage(new URL(organizationPageUrl).pathname);

  return { openedNewsletterId, openNewsletter, closeNewsletter };
};
